import { minutesToMilliseconds } from "date-fns";
import { useQuery } from "react-query";
import { valueHoldings } from "../api/wallet/valueHoldings";
import { HoldingsValue } from "../helper/wallet/HoldingsValue";
import { ValueHoldingsResponse } from "../types/wallet/wallet";
import { WALLETS_QUERY_CACHE_KEY } from "./actions/wallet";

export const useValueHoldings = () =>
  useQuery<ValueHoldingsResponse, unknown, HoldingsValue>(
    [...WALLETS_QUERY_CACHE_KEY, "valuations"],
    valueHoldings,
    {
      staleTime: minutesToMilliseconds(15), // refresh valuations after
      select: (data) => new HoldingsValue(data),
    }
  );
